import React from 'react';
import Bounce from 'react-reveal/Bounce';
import Img from 'gatsby-image';
import { useVoice } from '../hooks/useVoice';

function ServiceCard({ service, count }) {
  const Speak = useVoice();

  return (
    <Bounce>
      <div className='solar-service-card'>
        <img src={service.image} alt='' />
        <div className='content'>
          <h2 className='title'> {service.title}</h2>
          <p>
            {service.text} <Speak text={service.text} />
          </p>
        </div>
      </div>
    </Bounce>
  );
}

export default ServiceCard;
